import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import footerBg from "../../assets/Indian-Flag.png";
import JD from "../../assets/jd.svg";
import { Link } from "react-router-dom";

export default function FooterLayout() {
  const currentYear = new Date().getFullYear();
  return (
    <Container
      fluid
      className="bg-dark py-5 text-white"
      style={{
        backgroundImage: `linear-gradient(rgba(33, 51, 96, 0.8), rgba(33, 51, 96, 0.7)), url(${footerBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        {/* Corrected Single Master Row for the 12-Column Grid */}
        <Row className="g-5 justify-content-between">
          {/* Column 1: Corporate Office Info Panel (Takes 4 columns on large screens) */}
          <Col lg={4} md={6} sm={12}>
            <div className="d-flex flex-column gap-4">
              <div>
                <h6
                  className="text-light text-uppercase fw-bold mb-2 small"
                  style={{ letterSpacing: "0.5px" }}
                >
                  Kolhapur Office Address:
                </h6>
                <p className="text-light fw-medium lh-base mb-0 small">
                  B9, Raysons Prestige, In Front Of Damini Hotel,
                  <br />
                  Tarabai Park,
                  <br />
                  Kolhapur-416003,
                  <br />
                  Maharashtra, India
                </p>
              </div>

              <div>
                <h6
                  className="text-light text-uppercase fw-bold mb-2 small"
                  style={{ letterSpacing: "0.5px" }}
                >
                  Sangli Office Address:
                </h6>
                <p className="text-light fw-medium lh-base mb-0 small">
                  At. Radewadi (santgon),
                  <br />
                  post Ankalkhop,
                  <br />
                  Tal palus, Dist Sangli,
                  <br />
                  Maharashtra, India.
                </p>
              </div>

              <div>
                <h6
                  className="text-light text-uppercase fw-bold mb-2 small"
                  style={{ letterSpacing: "0.5px" }}
                >
                  Working Hours:
                </h6>
                <p className="text-light fw-medium lh-base mb-0 small">
                  10:00am to 6:00pm
                </p>
              </div>
            </div>
          </Col>

          {/* Column 2: Company Links (Takes 2 columns on large screens) */}
          <Col lg={2} md={4} sm={6} xs={12}>
            <h6 className="text-white fw-semibold text-uppercase mb-3 fs-6">
              Company
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a
                  href="#about"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#gallery"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Gallery
                </a>
              </li>
              <li>
                <a
                  href="#projects"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Projects
                </a>
              </li>
              <li>
                <a
                  href="#timeline"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Timeline
                </a>
              </li>
            </ul>
          </Col>

          {/* Column 3: Apps Pages Links (Takes 2 columns on large screens) */}
          <Col lg={2} md={4} sm={6} xs={12}>
            <h6 className="text-white fw-semibold text-uppercase mb-3 fs-6">
              Our Work
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a
                  href="#calendar"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Calendar
                </a>
              </li>
              <li>
                <a
                  href="#mailbox"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Mailbox
                </a>
              </li>
              <li>
                <a
                  href="#chat"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Chat
                </a>
              </li>
              <li>
                <a
                  href="#deals"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Deals
                </a>
              </li>
              <li>
                <a
                  href="#kanban"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Kanban Board
                </a>
              </li>
            </ul>
          </Col>

          {/* Column 4: Support Links (Takes 2 columns on large screens) */}
          <Col lg={2} md={4} sm={6} xs={12}>
            <h6 className="text-white fw-semibold text-uppercase mb-3 fs-6">
              Support
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <a
                  href="#faq"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </Col>
          <Col lg={2} md={4} sm={6} xs={12}>
            <h6 className="text-white fw-semibold text-uppercase mb-3 fs-6">
              Quick Links
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-decoration-none small"
                  style={{ color: "#878a99" }}
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        {/* Horizontal Divider Line */}
        <hr
          style={{ borderColor: "rgba(255, 255, 255, 0.08)" }}
          className="my-4"
        />

        {/* 2. Bottom Copyright and Social Profiles Bar */}
        <Row className="align-items-center gy-3">
          {/* Copyright text containing dynamic live year */}
          <Col sm={6} className="text-center text-sm-start">
            <p className="mb-0 small" style={{ color: "#878a99" }}>
              {currentYear} © TSM
            </p>
          </Col>

          {/* Circular Grey Action Buttons */}
          <Col sm={6} className="text-center text-sm-end">
            <div className="d-flex justify-content-center justify-content-sm-end align-items-center gap-2">
              {[
                { icon: "bi-facebook", link: "#" },
                {
                  icon: "bi-instagram",
                  link: "https://www.instagram.com/tsmofficial.pvt.ltd?igsh=MTZjeW12d2VpNHExNQ==",
                },
                { icon: "bi-linkedin", link: "#" },
                { icon: "bi-google", link: "#" },
                {
                  type: "svg",
                  icon: JD,
                  link: "https://www.justdial.com/Kolhapur/tushar-suryawanshi-management-pvt-ltd-t/0231PX231-X231-250517150546-I3I2_BZDET?ref=auto&searchfrom=auto|home",
                },
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.link}
                  className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none text-light transition-all"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    fontSize: "14px",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(255, 255, 255, 0.15)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(255, 255, 255, 0.05)")
                  }
                >
                  {social.type === "svg" ? (
                    <img
                      src={social.icon}
                      alt="Icon"
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <i
                      className={`bi ${social.icon}`}
                      style={{ fontSize: "1rem" }}
                    ></i>
                  )}
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
